<template>
    <v-container style="width: 90% !important;" class="my-10">
        <ValidationProvider :name="item.name"
                            :rules="item.rules"
                            mode="eager"
                            ref="provider"
                            v-bind:key="item.name"
                            v-for="item in items">
            <div slot-scope="{ errors }">
                <v-row no-gutters>

                    <!--Label for the form-->
                    <v-col xs="12" md="3" class="d-flex justify-end">
                        <div class="d-flex align-center justify-end">
                            <p class="subtitle-3 font-weight-bold text--primary"
                               :style="{color: errors.length > 0 ? 'rgb(236 29 36) !important' : '', opacity: 0.8, marginTop: '5px',
                               marginRight: '15px'}">{{ item.title }}:</p>
                        </div>
                    </v-col>

                    <!-- Text field -->
                    <v-col xs="12" md="9" style="height: 65px">
                        <v-text-field dense
                                      :name="item.name"
                                      outlined
                                      :placeholder="item.rules && item.rules.includes('required') ? 'Obavezno..' : ''"
                                      :prepend-icon="item.icon"
                                      v-if="item.tag === 'input'"
                                      v-model="form[item.name]">
                        </v-text-field>


                        <!-- Select field -->
                        <v-autocomplete outlined
                                        dense
                                        :placeholder="item.rules ? 'Obavezno..' : ''"
                                        :items="item.source"
                                        :name="item.name"
                                        :prepend-icon="item.icon"
                                        item-text="text"
                                        item-value="value"
                                        v-if="item.tag === 'select'"
                                        v-model="form[item.name]">
                        </v-autocomplete>

                        <!-- Multiselect field -->

                        <v-autocomplete outlined
                                        dense
                                        :placeholder="item.rules ? 'Obavezno..' : ''"
                                        :items="item.source"
                                        :name="item.name"
                                        chips
                                        multiple
                                        v-if="item.tag === 'multiselect'"
                                        v-model="form[item.name]">
                        </v-autocomplete>


                        <!-- HTML editor -->

                        <div style="height: 320px"
                             v-if="item.tag === 'html'">
                            <br/>

                            <span class="subheading">
                                    {{ item.title }} <br/>
                                </span>

                            <vue-editor
                                    :name="item.name"
                                    style="height: 200px; margin-top: 5px;"
                                    v-model="form[item.name]">
                            </vue-editor>

                            <!--
                            <p v-if="item.validate"
                               class="form-error" style="padding: 10px;">
                                Ovo polje je obavezno.
                            </p>
                            -->
                        </div>

                        <div class="hidden-sm-and-up" style="height: 60px;"
                             v-if="item.tag === 'html'"></div>


                        <!-- File(s) uploads -->

                        <div v-if="item.tag === 'file' || item.tag === 'files'">
                            <br/>

                            <span class="subheading">{{ item.title }} <br/> </span>

                            <vue-dropzone
                                    :id="'dropZone_' + item.name"
                                    :name="item.name"
                                    :options="item.tag === 'file' ? dzSingle : dzMulti"
                                    @vdropzone-complete="(file) => onFileUpload(file, item)"
                                    style="margin-top: 5px;"
                                    v-if="dropzones">
                            </vue-dropzone>
                        </div>


                        <!-- Date picker -->

                        <v-menu
                                v-model="menu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                                v-if="item.tag === 'date'"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                        v-model="form[item.name]"
                                        label="Odaberite datum"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="form[item.name]" scrollable>

                            </v-date-picker>
                        </v-menu>


                        <!-- Time picker -->

                        <br v-if="item.tag === 'time'"/>

                        <v-time-picker
                                :landscape="false"
                                :name="item.name"
                                format="24hr"
                                v-if="item.tag === 'time'"
                                v-model="form[item.name]">
                        </v-time-picker>

                    </v-col>
                </v-row>
            </div>
        </ValidationProvider>
    </v-container>
</template>

<script>

  import {serverBus} from "../../main";

  import {VueEditor} from 'vue2-editor'
  import VueDropzone from 'vue2-dropzone'

  import {extend, setInteractionMode, ValidationProvider} from 'vee-validate';
  import {digits, email, max, min, required} from 'vee-validate/dist/rules';

  import 'vue2-dropzone/dist/vue2Dropzone.min.css'

  export default {

    components: {
      VueEditor,
      VueDropzone,
      ValidationProvider
    },

    props: ['table', 'resource'],

    created: function () {
      setInteractionMode('eager');

      extend('min', min);
      extend('max', max);
      extend('digits', digits);
      extend('email', email);
      extend('required', {...required, message: 'Ovo polje je obavezno.'});

      serverBus.$on('save-add-view-data', (dialog = false) => {
        let errors = false;
        for (let i = 0; i < this.$refs.provider.length; i++) {
          this.$refs.provider[i].validate().then(() => {
            if (this.$refs.provider[i].errors.length > 0) {
              errors = true;
            }
          })
        }
        setTimeout(() => {
          if (!errors) {
            this.saveResource(dialog);
          } else {
            serverBus.$emit('show-snackbar', false, 'Provjerite jeste li unijeli sva potrebna polja na ispravan način!')
          }
        }, 120)
      });

      serverBus.$on('get-add-view-data', () => {
        this.getResource();
        this.getResourceFormData();

        this.tableActive = this.table;

        if (this.table === 'djelatnik') {
          this.form.country_of_birth = 'bih';
        }
      });

      serverBus.$on('edit-add-view-item', (attributes) => {
        for (let i = 0; i < attributes.length; i++) {
          this.form[attributes[i].key] = attributes[i].value;
        }
      });
    },

    computed: {
      activeRole() {
        return this.$store.getters.getCurrentRole;
      }
    },

    methods: {
      getResourceFormData() {
        if (this.table === this.tableActive) return;

        this.items = null;

        this.$axios.post(this.table + '/obrazac').then(response => {
          this.items = response.data;
        });
      },

      getResource() {
        if (this.resource.id == null || this.resource.id === -1) return;

        this.$axios.post(this.table + '/' + this.resource.id).then(response => {
          this.form = response.data;
        });
      },

      saveResource(closeDialog) {
        this.loading = true;
        this.$axios.post(this.table + '/spremi', this.form).then(() => {
          serverBus.$emit('show-snackbar');
          if (closeDialog) {
            this.form = {};

            serverBus.$emit('close-add-view-dialog');
          }

          /* ako je uređivanje vršeno s pogleda moja_skola dispatchaj akciju getSchool kako bi se ažurirala škola i na pogledu moja_skola */
          if(this.activeRole.role_id === 3 && this.table === 'skola') {
            this.$store.dispatch("getSchool");
          }

          serverBus.$emit('perform-action-after-save');
        }).catch(function () {
          serverBus.$emit('show-snackbar', false);
        }).finally(() => {
          serverBus.$emit(closeDialog ? 'reload-all-data' : 'reload-table-data');

          this.loading = false;
        });
      }
      ,

      onFileUpload(file, item) {
        if (file.accepted) {
          if (item.tag === 'file') {
            this.form[item.name] = file.xhr.response;
          } else if (item.tag === 'files') {
            if (this.form[item.name] == null) this.form[item.name] = [];

            this.form[item.name].push(file.xhr.response);
          }

          serverBus.$emit('show-snackbar', true,);
        } else {
          serverBus.$emit('show-snackbar', false);
        }
      }
    }
    ,

    beforeDestroy() {
      serverBus.$off('save-add-view-data');
      serverBus.$off('get-add-view-data');
      serverBus.$off('edit-add-view-data');
    }
    ,

    data: function () {
      return {
        form: {},
        items: [],
        loading: false,
        dropzones: true,
        tableActive: '',
        dzSingle: {
          url: 'upload',
          method: 'POST',
          maxFilesize: 20,
          maxFiles: 1,
          dictDefaultMessage: 'Priložite datoteku..',
        },
        dzMulti: {
          url: 'upload',
          method: 'POST',
          maxFilesize: 20,
          dictDefaultMessage: 'Priložite jednu ili više datoteka..'
        },
        //Date options
        date: new Date().toISOString().substr(0, 10),
        menu: false
      }
    }
    ,
  }
</script>
